import { ErrorsService } from "src/app/services/common/errors.service";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { IPlacementReservationAdd } from "./../../../interfaces/placementReservationAdd";
import { Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder } from "@angular/forms";

import { IBranch } from "src/app/interfaces/branch";
import { IPlacementType } from "src/app/interfaces/placementType";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IPlacementReservationTime } from "src/app/interfaces/placementReservationTime";
import { AccountService } from "./../../../services/http/business/account/account.service";
import { IPlacementTimeSheetGetDateList } from "src/app/interfaces/placement-timeSheet-GetDateList";
import { PlacementTypeService } from "src/app/services/http/business/placement/placement-type.service";
import { PlacementTiemSheetService } from "src/app/services/http/business/placement/placement-tiem-sheet.service";
import { PlacementReservationService } from "src/app/services/http/business/placement/placement-reservation.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BIDService } from "src/app/services/common/bid.service";
import { MatSelect, MatSelectChange } from "@angular/material";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { PlacementPaymentComponent } from "../placement-payment/placement-payment.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { Router } from "@angular/router";
import { HttpHeaders } from "@angular/common/http";
import { IError } from "src/app/interfaces/error.interface";

// import { IConfirm } from "src/app/interfaces/confirm";
//import { ConfirmComponent } from "src/app/components/confirm/confirm.component";

@Component({
  selector: "app-placement-reservation-entry",
  templateUrl: "./placement-reservation-entry.component.html",
  styleUrls: ["./placement-reservation-entry.component.css"],
  providers: [ErrorsService]
})
export class PlacementReservationEntryComponent implements OnInit, OnDestroy {
  param: any;
  errorList: IError[] = [];
  shouldRegister: boolean = false;
  errObject: any;
  personInfo: any;
  isOwner: boolean;
  bracnchId: string;
  errors = new Array();
  nationalCode: string;
  reserveTimeList: any;
  notExistTime = false;
  companyList: ICompany[];
  branchesList: IBranch[];
  hideForm: boolean = true;
  hideNaForm: boolean = false;
  nationalcodeForm: FormGroup;
  reservationAddForm: FormGroup;
  hideTimeReserved: boolean = true;
  hidePlacementDate: boolean = true;
  hidePlacementType: boolean = true;
  placementTypeList: IPlacementType[];
  reservationDateList: IPlacementTimeSheetGetDateList[];

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private cidService: CIDService,
    private bidService: BIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private router: Router,
    private branchSewrvice: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private accountService: AccountService,
    private placementTypeService: PlacementTypeService,
    private reservationService: PlacementReservationService,
    private placementTimeSheetServie: PlacementTiemSheetService,
    private dialogRef: MatDialogRef<PlacementReservationEntryComponent>
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createNationalcodeForm();
    // this.getCompanyList();

  }

  setCid(e: MatSelectChange) {
    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.bidService.setBID("");
    }
    this.getBranches(e.value);
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.bidService.removeBID();
        this.getCompanyList();

        this.createReservationAddForm();
      } else {
        this.getBranches(this.cidService.getCID());

        this.createReservationAddForm();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  submitNaCode(form: any) {
    //this.bidService.removeBID();
    this.errors = new Array();
    this.accountService.getSimpleUserInfo(form.nationalCode).subscribe(
      res => {
        this.reservationAddForm.controls["NationalCode"].patchValue(
          form.nationalCode
        );
        this.personInfo = res;
        this.hideForm = false;
        if (!this.isOwner) {
          this.loadPlacementTypeDirect(this.bidService.getBID());
        }

        this.hideNaForm = true;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
        this.shouldRegister = this.errorList.filter((e: IError)=> e.code == 13007)[0] == null ? false : true;
      }
    );
  }

  getRealTime(reserveTime) {
    var dateObj = new Date();
    var hours = dateObj.getHours();
    var minutes = dateObj.getMinutes();
    var seconds = dateObj.getSeconds();

    var timeString = hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + ':' +
      seconds.toString().padStart(2, '0');
    if (reserveTime >= timeString)
      return true;
    else
      return false;
  }

  createNationalcodeForm() {
    this.nationalcodeForm = this.fb.group({
      nationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ]
    });
  }

  createReservationAddForm() {

    this.reservationAddForm = this.fb.group({
      NationalCode: [this.nationalCode],
      Date: [null, Validators.compose([Validators.required])],
      TimeReserved: [null, Validators.compose([Validators.required])],
      BranchEncryptId: [null, Validators.compose([Validators.required])],
      PlacementTypeId: [null, Validators.compose([Validators.required])],
      CanAddAndReplace: [false]
    });
    if (!this.isOwner) {
      this.reservationAddForm.controls['BranchEncryptId'].setValue(this.bidService.getBID());
    }
  }
  routToRegisterdirect() {


    this.onNoClick();
    this.router.navigate(['/management/registerdirect'])
  }
  getBranches(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchSewrvice.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchesList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementType(e: MatSelect) {
    this.placementTypeList = [];
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.reservationAddForm.controls['PlacementTypeId'].setValue(null);
    this.reservationAddForm.controls['Date'].setValue(null);
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    this.bracnchId = e.value;
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.placementTypeService.list(0, 0).subscribe(
      res => {
        this.placementTypeList = res.DataList;
        this.hidePlacementType = false;
        this.hidePlacementDate = true;
        this.hideTimeReserved = true;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadPlacementTypeDirect(branchEncryptId: string) {
    this.placementTypeList = [];
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.reservationAddForm.controls['PlacementTypeId'].setValue(null);
    this.reservationAddForm.controls['Date'].setValue(null);
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    this.bracnchId = branchEncryptId;
    if (this.isOwner)
      this.bidService.setBID(branchEncryptId);
    this.placementTypeService.list(0, 0).subscribe(
      res => {
        this.placementTypeList = res.DataList;
        this.hidePlacementType = false;
        this.hidePlacementDate = true;
        this.hideTimeReserved = true;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }



  loadReservationDate(BranchEncryptId, placementType) {
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.reservationAddForm.controls['Date'].setValue(null);
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    var data: IPlacementReservationTime = {
      BranchEncryptId: BranchEncryptId,
      PlacementTypeId: placementType
    };
    this.placementTimeSheetServie.GetDateList(data).subscribe(
      res => {
        this.reservationDateList = res;
        this.hidePlacementDate = false;
        this.hideTimeReserved = true;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  loadReservationDateDirect(placementType) {
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.reservationAddForm.controls['Date'].setValue(null);
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    var data: IPlacementReservationTime = {
      BranchEncryptId: this.bidService.getBID(),
      PlacementTypeId: placementType
    };
    this.placementTimeSheetServie.GetDateList(data).subscribe(
      res => {
        this.reservationDateList = res;
        this.hidePlacementDate = false;
        this.hideTimeReserved = true;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementReservationTime(
    BranchEncryptId: string,
    PlacementTypeId: number,
    Date: Date
  ) {
    console.log('a');
    this.reserveTimeList = [];
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    var data: IPlacementReservationTime = {
      Date: Date,
      AfterNow: true,
      BranchEncryptId: BranchEncryptId ? BranchEncryptId : this.bidService.getBID(),
      PlacementTypeId: PlacementTypeId
    };
    this.reservationService.placementReservationTime(data).subscribe(
      res => {
        this.reserveTimeList = res;
        if (res.length <= 0)
          this.notExistTime = true;
        else
          this.notExistTime = false;
        this.hideTimeReserved = false;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  loadPlacementReservationTimeDirect(
    PlacementTypeId: number,
    Date: Date
  ) {
    console.log('a');

    this.reserveTimeList = [];
    this.reservationAddForm.controls['TimeReserved'].setValue(null);
    var data: IPlacementReservationTime = {
      Date: Date,
      AfterNow: true,
      BranchEncryptId: this.bidService.getBID(),
      PlacementTypeId: PlacementTypeId
    };
    this.reservationService.placementReservationTime(data).subscribe(
      res => {
        this.reserveTimeList = res;

        if (res.length <= 0)
          this.notExistTime = true;
        else
          this.notExistTime = false;
        this.hideTimeReserved = false;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  addReservation(form: IPlacementReservationAdd) {
    this.errors = new Array();
    this.reservationService.placementReservationAdd(form).subscribe(
      res => {
        if (parseInt(res.returnValue2) > 0) {
          this.dialog.open(PlacementPaymentComponent, {
            data: res.returnValue
          }).afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
        else {
          this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }

      },
      err => {

        if (err.error.ErrorData.Value.Errors[0].Message.includes("96001")) {
          let confirm: IConfirm = {
            accept: true,
            message: this.translate.get("serviceErrors.96001"),
            alert: null,
            yesLabel: this.translate.get("label.yes"),
            noLabel: this.translate.get("label.no")
          };

          this.dialog.open(ConfirmComponent, {
            width: "400px",
            data: confirm
          })
            .afterClosed()
            .subscribe(res => {
              if (res) {
                this.errors = new Array();
                form.CanAddAndReplace = true;
                this.addReservation(form)

              }
            });

        }
        else {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
          this.shouldRegister = this.errorList.filter((e: IError)=> e.code == 13007)[0] == null ? false : true;
        }

      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.isOwner) {
      this.bidService.setBID("");
    }
  }
}
